module.exports = __webpack_public_path__ + "static/img/solu1.26a381d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Solution/img/solu1.jpg
// module id = dGl9
// module chunks = 1